module.exports = __webpack_public_path__ + "7ba1a816bde00d2ef025f96147d9e875.svg";